import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import trash from '../../Assets/AlertIcon/trash.svg';
import audit from '../../Assets/AlertIcon/report-search.svg';
import edit from '../../Assets/AlertIcon/edit.svg';
import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined';
import RingExportModal from './ring_export_modal.component';

const ITEM_HEIGHT = 48;

export default function RingMenuOptions({ ring, onDelete, onEdit, onAudit, onExport, onAddCost }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openExportModal, setOpenExportModal] = React.useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation(); // Prevent ring selection when clicking menu
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setAnchorEl(null);
  };

  const handleDelete = (event) => {
    event.stopPropagation();
    handleClose();
    if (onDelete) {
      onDelete(ring);
    }
  };

  const handleEdit = (event) => {
    event.stopPropagation();
    handleClose();
    if (onEdit) {
      onEdit(ring);
    }
  };

  const handleAudit = (event) => {
    event.stopPropagation();
    handleClose();
    if (onAudit) {
      onAudit(ring);
    }
  };

  const handleExport = (event) => {
    event.stopPropagation();
    handleClose();
    setOpenExportModal(true);
  };

  const handleExportOption = async (selectedRing, format) => {
    try {
      // Call the parent export function with the format
      if (onExport) {
        await onExport(selectedRing, format);
      }
    } catch (error) {
      console.error('Export error:', error);
      throw error;
    }
  };

  const handleAddCost = (event) => {
    event.stopPropagation();
    handleClose();
    if (onAddCost) {
      onAddCost(ring);
    }
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <IconButton
        aria-label="more"
        id="ring-menu-button"
        aria-controls={open ? 'ring-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        size="small"
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        id="ring-menu"
        MenuListProps={{
          'aria-labelledby': 'ring-menu-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
            },
          },
        }}
      >
        <MenuItem onClick={handleAddCost} disableRipple>
          <AddCircleOutlineIcon
            style={{
              fontWeight: '400',
              color: '#433f4f',
            }}
          />
          <div
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Add Cost
          </div>
        </MenuItem>
        <MenuItem onClick={handleExport} disableRipple>
          <GetAppOutlinedIcon
            style={{
              fontWeight: '400',
              color: '#433f4f',
            }}
          />
          <div
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Export
          </div>
        </MenuItem>
        <MenuItem onClick={handleEdit} disableRipple>
          <img alt="" src={edit} />
          <div
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Edit Name
          </div>
        </MenuItem>
        <MenuItem onClick={handleAudit} disableRipple>
          <img alt="" src={audit} />
          <div
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Audit log
          </div>
        </MenuItem>
        <MenuItem onClick={handleDelete} disableRipple>
          <img alt="" src={trash} />
          <div
            style={{
              marginLeft: '5px',
              color: '#090C0D',
              fontSize: 14,
              fontFamily: 'Poppins',
              fontWeight: '400',
              wordWrap: 'break-word',
            }}
          >
            Delete
          </div>
        </MenuItem>
      </Menu>

      {/* Export Modal */}
      <RingExportModal
        open={openExportModal}
        onClose={() => setOpenExportModal(false)}
        ring={ring}
        onExport={handleExportOption}
      />
    </div>
  );
}
